import React, { useEffect, useState } from "react";
import { GestionAlmacenApi } from "../api/GestionAlmacenApi";
import { NotificationManager } from "react-notifications";
import Swal from "sweetalert2";
import { getErrorFromResponse } from "../../../../../../../utility/utils";

export const useGestionAlmacen = (almacenInventarioId, regresar) => {
    const { getAlmacenDetalle, guardarGestionAlmacen, cargando } =
        GestionAlmacenApi();

    const [almacenDetalle, setAlmacenDetalle] = useState({});
    const [movimientos, setMovimientos] = useState([]);

    const GetAlmacenDetalle = async () => {
        try {
            const data = await getAlmacenDetalle(almacenInventarioId);

            setAlmacenDetalle(data);
            setMovimientos(data.recepciones || []);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el detalle del almacen",
            );
            Swal.fire({
                title: "Error",
                text: errorMsg,
                type: "error",
            });
            setAlmacenDetalle({});
            setMovimientos([]);
        }
    };

    const GuardarGestionAlmacen = async () => {
        try {
            const movimientosIds = movimientos.map((mov) => mov.id);

            // Lógica para guardar la gestión de almacén
            await guardarGestionAlmacen(almacenInventarioId, {
                movimientos_ids: movimientosIds,
            });

            NotificationManager.success(
                "Gestión de almacén guardada con éxito",
                "Éxito",
                3000,
            );

            regresar();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al guardar la gestión de almacén",
            );
            Swal.fire({
                title: "Error",
                text: errorMsg,
                type: "error",
            });
        }
    };

    useEffect(() => {
        GetAlmacenDetalle();
    }, [almacenInventarioId]);

    return {
        almacenDetalle,
        movimientos,
        setMovimientos,
        GuardarGestionAlmacen,
        cargando,
    };
};
